import { render } from "./AuthorConfirmPage.vue?vue&type=template&id=0e223ee9&scoped=true&ts=true"
import script from "./AuthorConfirmPage.vue?vue&type=script&lang=ts"
export * from "./AuthorConfirmPage.vue?vue&type=script&lang=ts"

import "./AuthorConfirmPage.vue?vue&type=style&index=0&id=0e223ee9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e223ee9"]])

export default __exports__